import React from 'react';
import {useDispatch} from 'react-redux';

import {TAnyActionCreator, TAnyThunkCreator} from '@edna/models/apiModel';

type TDispatchMap = Record<string, TAnyActionCreator | TAnyThunkCreator>;

// TODO удалить и использовать вместо этого напрямую action из модель. Например: dispatch(model.action.requestItem)
const useMemoizedDispatch = <T extends TDispatchMap = TDispatchMap>(dispatchMap: T) => {
  const dispatch = useDispatch();

  return React.useMemo(
    () =>
      Object.entries(dispatchMap).reduce<T>(
        (actions, [actionName, actionCreator]) => ({
          ...actions,
          [actionName]: (...args) => dispatch(actionCreator(...args)),
        }),
        {} as T,
      ),
    [dispatch, dispatchMap],
  );
};

export default useMemoizedDispatch;
